import { TRANSLATION_KEYS } from './translations'

export { STATUS_OPTIONS } from 'partner360/entities/keyInitiatives/model/status'

export const globalPartnerPlanPage = 'jbl-hpscoutso-global'

export const URL_DEPS = ['pid', 'jbp-tab']

// Keep the section-level applicability and program switches available for a future rollout.
export const SHOW_KEY_INITIATIVES_SECTION_SWITCHES = false

export const BASE_COLUMNS = [
  { field: '', title: '', hideSettings: true, priority: 1, disableSort: true },
  {
    field: 'Development',
    title: 'keyinitiatives-development',
    priority: 3,
  },
  {
    field: 'Description',
    title: 'keyinitiatives-description',
    priority: 4,
  },
  {
    field: 'SubCategoryCounts',
    title: 'keyinitiatives-sub-counts',
    priority: 5,
  },
]

export const GENERAL_COLUMNS = [
  ...BASE_COLUMNS,
  {
    field: 'Category',
    title: TRANSLATION_KEYS.tableColumns.category,
    priority: 2,
  },
]

export const KEY_INITIATIVES_FORM = {
  formId: '801',
  code: 'PartnerKeyInitiatives',
}

export const ATTACHMENT_TYPE = 'KeyInitiatives'
